export const getUTCDate = (date: Date = new Date(), resetHours = true): Date => {
  date.setUTCFullYear(date.getFullYear());
  date.setUTCMonth(date.getMonth());
  date.setUTCDate(date.getDate());
  if (resetHours) {
    date.setUTCHours(0, 0, 0, 0);
  } else {
    const localOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localTime = date.getTime();
    const utcTime = localTime + localOffset;
    const newUtcDate = new Date(utcTime);

    date.setUTCHours(
      newUtcDate.getUTCHours(),
      newUtcDate.getUTCMinutes(),
      newUtcDate.getUTCSeconds(),
      newUtcDate.getUTCMilliseconds(),
    );
  }

  return date;
};

export const isSameDay = (date1: Date, date2: Date) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const getPreviousMonthUTC = () => {
  const now = new Date();

  return new Date(Date.UTC(now.getFullYear(), now.getMonth() - 1));
};
